import { For, Match, Show, Switch, createMemo } from "solid-js";
import Flexbox from "../../st-flexbox/st-flexbox";
import { StepContext, requireWizardContext } from "../WizardContext";
import styles from '../st-wizard.module.css';

type TabState = 'active' | 'complete' | 'default';

export function Header() {
    const ctx = requireWizardContext();

    function selectStep(step: StepContext) {
    }

    function getTabState(step: StepContext): TabState {
        if (ctx.currStep() === step.id) {
            return 'active';
        }
        else if (step.completed()) {
            return 'complete';
        }
        return 'default';
    }

    return <Flexbox dir="horizontal" middle role="tablist" class={styles.header} >
        <For each={ctx.validSteps()}>{step => <>
            <Flexbox dir="vertical" as="a" class={styles.tab} data-state={getTabState(step)} role="tab" href="#" onClick={(ev: Event) => { ev.preventDefault(); selectStep(step); }} >
                <span>
                    <StepIcon state={getTabState(step)} size={ctx.size()} />
                </span>
                <span>{step.title}</span>
            </Flexbox>
            <Show when={step.id < ctx.validSteps().length - 1}>
                <Flexbox.Item auto class={styles.spacer} />
            </Show>
        </>}</For>
    </Flexbox>
}

function StepIcon(props: { state: TabState, size: 'small' | 'medium' }) {
    const sizePx = createMemo(() => {
        switch (props.size) {
            default:
            case 'medium':return 64;
            case 'small': return 48;
        }
    });

    return <span role="presentation">
        <svg width={sizePx()} height={sizePx()} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="24" cy="24" r="20" fill="transparent" stroke-width="4" stroke="currentColor" />
            <Switch>
                <Match when={props.state === 'active'}>
                    <circle cx="24" cy="24" r="14" fill="currentColor" />
                </Match>
                <Match when={props.state === 'complete'}>
                    <path
                        d="M16 24 L22 30 L32 20"
                        stroke="currentColor"
                        stroke-width="4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </Match>
            </Switch>
        </svg>
    </span>
}
